export const getActiveElement = (
  activeDocument: Document | ShadowRoot,
): HTMLElement | null => {
  const activeElement = activeDocument.activeElement;
  if (!activeElement) {
    return activeElement as null;
  }
  if (activeElement.tagName === "IFRAME") {
    const iframes = Array.from(document.getElementsByTagName("iframe"));
    if (iframes.includes(activeElement as HTMLIFrameElement)) {
      const iframeActiveElement = activeElement as HTMLIFrameElement;
      const iframeActiveDocument =
        iframeActiveElement.contentDocument ||
        iframeActiveElement.contentWindow?.document;
      if (!iframeActiveDocument) return activeElement as HTMLElement;
      return getActiveElement(iframeActiveDocument);
    }
  }
  if (!activeElement.shadowRoot) {
    return activeElement as HTMLElement;
  }
  if (activeElement.shadowRoot) {
    return getActiveElement(activeElement.shadowRoot);
  }
  return activeElement as HTMLElement;
};
